import MapModel from './maps/MapModel';
import MapView from './maps/MapView';
import MapObjectBaloonManager from './maps/MapObjectBaloonManager';
import DirectionsModal from './modals/DirectionsModal';
import { mapUrl, mapData } from './maps/map-data';
// import LoginModal from './modals/LoginModal';
// import AjaxFormModal from './modals/AjaxFormModal';
// import GalleryCarouselModal from './modals/GalleryCarouselModal';
// import FullscreenGalleryCarouselModal from './modals/FullscreenGaleryCarouselModal';
// import DesktopSearchbarLocationModal from './modals/DesktopSearchBarLocationModal';

import $ from 'jquery';

/* global google */

$('.js-open-directions-button').on('click', event => {
  event.preventDefault();
  event.stopPropagation();
  const directionsStartString = $(
    '.js-directions-start',
    $(event.currentTarget).parents('.js-accordion-container'),
  ).val();
  if (directionsStartString.length > 1) {
    const modalBox = new DirectionsModal(
      directionsStartString,
      new google.maps.LatLng(mapData[0]['lat'], mapData[0]['lng']),
      $(event.currentTarget).attr('data-travel-method'),
    );
    modalBox.open();
  }
});

const mapModel = new MapModel(mapData, mapUrl);
const mapView = new MapView(mapModel, {
  container: $('.js-camp-map'),
  instance: $('.js-camp-map-instance'),
});
const mapObjectBallonManager = new MapObjectBaloonManager(mapModel, mapView);
window.setTimeout(() => {
  mapObjectBallonManager.show(mapData[0]['id']);
  mapView.map.setCenter(
    mapView.getCenterOffset(mapView.map.getCenter(), 0, -100),
  );
}, 200);

//const lm = new FullscreenGalleryCarouselModal('/ajax/gallery/48/');


//const lm = new GalleryCarouselModal('/acc-unit/148');

//const lm = new LoginModal(CampingAdriaticGlobals['login_url']);

//const lm = new DesktopSearchbarLocationModal();

// const lm = new AjaxFormModal('/forgotten-password', {
//   form_fields_container_selector: '#modalResponseContainer',
// });

//lm.open();

//window.setTimeout(() => lm.open(), 1000);




// WEBPACK FOOTER //
// ./src/js/bundle_camp_maps_directions.js